import * as React from "react";
import { useState } from "react";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ResultPageModel } from "../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { FundProduct } from "../../../../../Wrap/Models/Domains/Investment/FundProduct";
import { Investment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentDetailsPopupModal } from "../../../../Dashboard/Components/Clients/Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { Table } from "../../../Table/Table";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { FavouritesToggle } from "../Shared/FavouritesToggle";
import { Contents } from "../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Investment/Resource/Contents";
import { InvestmentsAction } from "../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Investment/Action/InvestmentAction";

interface IFundsSearchResultsProps {
    data: ResultPageModel<FundProduct>;
    allocationTable: any[];
    onPageChange: (pageIndex) => void;
    isFavourite?: boolean;
    index: number;
    researchIst: boolean;
}
export const FundSearchResults = (props: IFundsSearchResultsProps) => {
    const [isShowDetailModal, setShow] = React.useState(false);
    const [selectedInvestment, setSelected] = React.useState<Investment>(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [code, setCode] = useState({ key: "ProductCode", value: "Fund code" });
    const [data, setData] = useState<ResultPageModel<FundProduct>>(null);
    const [nonUKDomicileMessage, setNonUKDomicileMessage] = useState<string>("");

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        const curData = JSON.parse(JSON.stringify(data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable?.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            const curItem = (curData?.Results ?? []).find((item) => item.ProductId == ele.ProductId);
            const isFav = curItem ? curItem.IsFavourite : ele.IsFavourite;
            return { ...ele, isSelected: isSelected, IsFavourite: isFav };
        });

        setData(_data);
    }, [props.allocationTable]);

    React.useEffect(() => {
        const _data = JSON.parse(JSON.stringify(props.data));
        _data.Results = props.data.Results.map((ele) => {
            const isSelected = props.allocationTable?.some(
                (item) => item.Instrument?.ProductId == ele.ProductId || item.Investment?.ProductId == ele.ProductId
            );
            return { ...ele, isSelected: isSelected };
        });

        setData(_data);
    }, [props.data]);

    React.useEffect(() => {
        let isMounted = true; 
        InvestmentsAction.getNonUKDomicileMessage((res) => {
            if (isMounted) { 
            setNonUKDomicileMessage(res?.Template || "");
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);

    const renderInvestmentDetailPopupModal = (): JSX.Element => {
        if (!isShowDetailModal) {return null;}
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        setShow(false);
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    };

    const onInvestmentSelected = (investment) => {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            setSelected(d);
            setShow(true);
        });
    };

    const codeOptions = [
        { key: "ProductCode", value: "Fund code" },
        { key: "Isin", value: "ISIN" },
        { key: "Sedol", value: "SEDOL" },
        { key: "ProductId", value: "Mex ID" },
    ];
    return (
        <div className="panel pr-0 pl-0 pb-0 pt-0 mt-40">
            <h3>{props.isFavourite ? "Favourites list" : "Selection"}</h3>
            <p>Funds available: {props.data.Pager.TotalRecords}</p>
            <Table
                data={data?.Results}
                cssWrapper={"no-sided-padding has-favourite-toggle"}
                showEmptyMsg
                cssEmptyMessage="warning-message mt-20"
                needPagination={{
                    totalNumOfResult: props.data.Pager.TotalRecords,
                    currentPage: currentPage,
                    onPaginationChange: (pageIndex) => {
                        setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex);
                    },
                }}
                col={[
                    {
                        title: "Fund name",
                        key: "Name",

                        render: (rowData, row, index) => {
                            return (
                                <FavouritesToggle
                                    cssWrapper="in-table"
                                    label={
                                        <a className="hyperlink" onClick={() => onInvestmentSelected(row)}>
                                            {rowData}
                                        </a>
                                    }
                                    onToggle={(v) => {
                                        InvestmentSelectionAction.setFavouriteProdcut(row.ProductId, v);
                                        const _data = JSON.parse(JSON.stringify(data));
                                        const product = _data?.Results?.find((ele) => ele.ProductId == row.ProductId);
                                        product.IsFavourite = v;
                                        setData(_data);
                                    }}
                                    isFavourite={row.IsFavourite}
                                    key={rowData}
                                />
                            );
                        },
                    },
                    {
                        title: (
                            <SelectEditor
                                options={codeOptions}
                                getText={(v) => v.value}
                                selected={code}
                                onChange={(v) => setCode(v)}
                                cssWrapper="mb-0 select-in-table"
                            />
                        ),
                        key: code.key,
                    },
                    props.researchIst
                        ? {
                              title: "ISIN",
                              key: "Isin",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "Fund type",
                              key: "FundType",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "AMC",
                              key: "AMC",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "TER",
                              key: "TER",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "OCF",
                              key: "OCF",
                          }
                        : null,
                    props.researchIst
                        ? {
                              title: "Asset class",
                              key: "AssetClass",
                          }
                        : null,
                    { title: "Sector", key: "Sector.Name" },
                    props.researchIst
                        ? {
                              title: "Status",
                              key: "",
                              render: (data) => {
                                  return "Tradeable";
                              },
                          }
                        : null,
                        {
                            title: "SDR",
                            key: "SDR",
                            render: (data, row: FundProduct) => {
                                return (
                                    <div>
                                        {!row.IsUKDomicile ? (
                                           <div
                                           dangerouslySetInnerHTML={{ __html: nonUKDomicileMessage }}
                                            />
                                        ) : (
                                            row.SdrLabelUrl && row.SdrLabelUrl.trim() !== '' && (
                                                <div>
                                                    <img
                                                        src={row.SdrLabelUrl}
                                                        alt="SDR Label"
                                                        style={{ maxWidth: '100px', height: 'auto', marginTop: '10px' }}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                );
                            },
                        },                                             
                    !props.researchIst
                        ? {
                              title: <span className="sr-only">select an investment</span>,
                              key: "isSelected",
                              render: (data, row) => {
                                  return !row.IsDeferred ? (
                                      <a
                                          className={"select-toggle"}
                                          onClick={() => {
                                              if (data) {return null;}
                                              if (props.index) {
                                                  InvestmentSelectionAction.setEditingTransferNumber(props.index);
                                              }
                                              InvestmentSelectionAction.addInvestment(row);
                                          }}
                                          aria-pressed={data}
                                      >
                                          <span className="label">{data ? "Added" : "Select"}</span>
                                      </a>
                                  ) : (
                                      row.IsDeferred && (
                                          <a className={"select-toggle"}>
                                              {" "}
                                              <span className="label">Deferred</span>{" "}
                                          </a>
                                      )
                                  );
                              },
                          }
                        : null,
                ]}
            />
            {renderInvestmentDetailPopupModal()}
        </div>
    );
};
